export default {
  home: 'Buat Pesanan',
  orders: 'Status Pesanan',
  account: 'Akun',
  accountInfo: 'Informasi Akun',
  changePassword: 'Ubah Kata Sandi',
  aboutUs: 'Tentang Kami',
  callUs: 'Hubungi Kami',
  logout: 'Logout',
  masterData: 'Master Data',
  userAdmin: 'User Admin',
  document: 'Dokumen',
  documentReport: 'Laporan'
}
